import React, { FC } from "react";
import { Stack, Typography } from "@mui/material";

import { Image } from "@src/types";
import { Colors } from "@src/gatsby-theme-material-ui-top-layout/colors";
import ButtonPicker from "../Buttons/picker";
import Markdown from "../Markdown";

import { UtmParameters } from "@src/helpers/utms";

interface AuthorProps {
  name: string;
  title?: string;
  image?: string;
}

interface BackLink {
  label: string;
  url: string;
}

interface Props {
  title: string;
  subtitle?: string;
  category?: string;
  description?: string;
  image?: Image;
  author?: AuthorProps;
  backLink?: BackLink;
  ctaButton?: { type: string; label?: string };
  slim?: boolean;
  additionalXPadding?: number;
  useMarkdownTitle?: boolean;
  ctaUtms?: UtmParameters;
}

const SimpleHero: FC<Props> = ({
  title,
  category,
  subtitle,
  description,
  image,
  author,
  backLink,
  ctaButton,
  slim = false,
  additionalXPadding = 0,
  useMarkdownTitle = false,
  ctaUtms = {},
}) => {
  return (
    <Stack
      alignItems="center"
      sx={{
        width: "100%",
        marginTop: "-68px",
        marginBottom:
          slim === true
            ? {
                xs: "40px",
                lg: "0px",
              }
            : "40px",
        paddingTop: "68px",
        backgroundColor: Colors.PrimaryContrast,
        overflow: "hidden",
      }}
    >
      <Stack
        direction={{ xs: "column", md: "row" }}
        maxWidth="700px"
        alignItems="center"
        justifyContent="center"
        textAlign="left"
        gap={5}
        sx={{
          position: "relative",
          width: "100%",
          padding: { xs: "16px 24px", lg: "24px 0 55px" },
          zIndex: "2",
        }}
      >
        <Stack
          maxWidth="1080px"
          alignItems="center"
          justifyContent="center"
          textAlign="center"
          direction="column"
          gap="20px"
          sx={{
            position: "relative",
            width: "100%",
            zIndex: "5",
          }}
        >
          {category && (
            <Stack direction="row" alignItems="center">
              {category && (
                <Typography variant="h6" sx={{ color: Colors.PrimaryMain }}>
                  {category}
                </Typography>
              )}
            </Stack>
          )}
          <Typography
            variant="h1"
            mb={slim === true ? "0px" : "20px"}
            mt="0"
            sx={{
              maxWidth: "850px",
              color: Colors.PrimaryMain,
              paddingX: {
                xs: "0px",
                md: `${additionalXPadding}px`,
              },
              "> h1, > p": {
                marginTop: "0px",
                marginBottom: "0px",
                p: {
                  marginTop: "0px",
                  marginBottom: "0px",
                },
              },
            }}
          >
            {useMarkdownTitle ? <Markdown content={title} /> : title}
          </Typography>
          {subtitle && (
            <Typography
              variant="h5"
              mb={2}
              sx={{
                fontSize: "24px",
                lineHeight: "38px",
                fontWeight: "500",
                color: Colors.PrimaryMain,
              }}
            >
              {subtitle}
            </Typography>
          )}
          {ctaButton && (
            <Stack>
              <ButtonPicker
                type={ctaButton.type}
                label={ctaButton.label}
                size="large"
                variant="contained"
                ctaUtms={ctaUtms}
              />
            </Stack>
          )}
        </Stack>
      </Stack>
    </Stack>
  );
};

export default SimpleHero;
